<template>
  <v-container grid-list-xs pt-0 pb-0>
    <v-card class="box-card pa-2">
      <v-layout row wrap justify-center>
        <v-flex xs12 sm12 md8>
          <span class="font-weight-bold">เลือกเกณฑ์การค้นหา:</span>
          <v-radio-group v-model="searchMode" row>
            <v-radio
              label="เลขประจำตัวประชาชน"
              value="card_id"
            />
            <v-radio
              label="ชื่อ-สกุล"
              value="name"
            />
            <v-radio
              label="หน่วยงานที่ได้รับต้นไม้"
              value="department"
            />
            <v-radio
              label="สถานที่ปลูก"
              value="location"
            />
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center>
        <v-flex
          v-if="searchMode === 'card_id'"
          xs12
          sm12
          md8
          d-flex
        >
          <v-text-field
            label="เลขประจำตัวประชาชน"
            prepend-inner-icon="info"
            solo
            hide-details
            color="blue"
            v-model="card_id"
            @keyup.enter="onSearch"
          ></v-text-field>
        </v-flex>

        <v-flex
          v-if="searchMode === 'name'"
          xs12
          sm12
          md4
          d-flex
          pr-1
        >
          <v-text-field
            label="ชื่อ"
            prepend-inner-icon="info"
            solo
            hide-details
            color="blue"
            v-model="name"
            @keyup.enter="onSearch"
          ></v-text-field>
        </v-flex>
        <v-flex
          v-if="searchMode === 'name'"
          xs12
          sm12
          md4
          d-flex
          pl-1
        >
          <v-text-field
            label="นามสกุล"
            prepend-inner-icon="info"
            solo
            hide-details
            color="blue"
            v-model="surname"
            @keyup.enter="onSearch"
          ></v-text-field>
        </v-flex>

        <v-flex
          v-if="searchMode === 'department'"
          xs12
          sm12
          md8
        >
          <v-card flat>
            <v-card-text class="pa-2">
              <v-layout row wrap>
                <v-flex xs12 md12 class="mt-0">
                  <span style="font-size:16px" class="font-weight-bold">
                    หน่วยงานที่ได้รับต้นไม้
                  </span>
                </v-flex>
                <v-flex xs12 md12>
                  <div class="mt-0">
                    <v-radio-group
                      class="mt-1"
                      hide-details
                      v-model="treeFromDepartment"
                    >
                      <div
                        v-for="(dept, index) in listDepartment"
                        :key="index"
                        :class="dept.department_id === 1 ? 'for-rfd' : 'for-other'"
                      >
                        <v-radio
                          :label="dept.department_name"
                          :value="dept.department_id"
                          hide-details
                        ></v-radio>

                        <!-- เลือกหน่วยงานภายใน (เฉพาะ กรมป่าไม้ id = 1) -->
                        <v-layout
                          row
                          wrap
                          v-show="dept.department_id === 1 && treeFromDepartment === 1"
                        >
                          <v-flex xs12 md12>
                            <v-autocomplete
                              :items="listSubSubDepartment"
                              label="พิมพ์ชื่อหน่วยงานภายใน"
                              v-model="subSubDepartment"
                              solo
                              item-text="department_name"
                              item-value="department_id"
                              hide-details
                              hide-selected
                              persistent-hint
                              color="blue"
                              :menu-props="menuProps"
                              clearable
                              return-object
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>

                        <!-- หน่วยงานอื่นๆ (id = 4) -->
                        <v-layout v-if="dept.department_id === 4">
                          <v-text-field
                            label="โปรดระบุ"
                            v-model="other"
                            solo
                            hide-details
                            :disabled="treeFromDepartment !== 4"
                            class="other"
                            @keyup.enter="onSearch"
                          ></v-text-field>
                        </v-layout>
                      </div>
                    </v-radio-group>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          v-if="searchMode === 'location'"
          xs12
          sm12
          md8
        >
          <v-card flat>
            <v-card-text class="pa-2">
              <v-layout row wrap>
                <v-flex xs12 md12 class="mt-0">
                  <span style="font-size:16px" class="font-weight-bold">
                    สถานที่ปลูก
                  </span>
                  <div class="body-2">
                    (กรุณาเลือกอย่างน้อย 1 ระดับ: จังหวัด / อำเภอ / ตำบล)
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-autocomplete
                    :items="listProvince"
                    v-model="selectedProvince"
                    label="จังหวัด"
                    item-text="province_name"
                    item-value="province_id"
                    solo
                    hide-details
                    color="blue"
                    return-object
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    :items="listAmphoe"
                    v-model="selectedAmphoe"
                    label="อำเภอ"
                    item-text="amphoe_name"
                    item-value="amphoe_id"
                    solo
                    hide-details
                    color="blue"
                    :disabled="!selectedProvince"
                    return-object
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    :items="listTambon"
                    v-model="selectedTambon"
                    label="ตำบล"
                    item-text="tambon_name"
                    item-value="tambon_id"
                    solo
                    hide-details
                    color="blue"
                    :disabled="!selectedAmphoe"
                    return-object
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md2>
          <v-btn color="primary" @click="onSearch">
            <v-icon class="mr-1">search</v-icon>
            ค้นหา
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card class="box-card pa-2 mt-3">
      <v-layout row wrap justify-space-between align-center>
        <v-flex xs12 md6>
          <span class="headline font-weight-bold">ผลการค้นหา</span>
        </v-flex>
        <v-flex xs12 md6 class="text-xs-right">
          <span v-if="totalCount !== null">
            จำนวน {{ totalCount | comma }} ราย
          </span>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        class="mt-2"
        hide-actions
        :pagination.sync="tablePagination"
        @update:pagination="onTablePagination"
        no-data-text="ไม่มีข้อมูล"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">
              {{ props.index + 1 + (page - 1) * pageSize }}
            </td>
            <td class="text-xs-left">
              {{ props.item.card_id }}
            </td>
            <td class="text-xs-left">
              {{ props.item.title || '-' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.name || '-' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.surname || '-' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.companyname || '-' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.total_plant_amount }}
            </td>
            <td class="text-xs-right">
              <v-btn small color="primary" @click="goToUserDetail(props.item)">
                <v-icon small class="mr-1">edit</v-icon>
                แก้ไข
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-layout row wrap justify-center v-if="pageCount > 1">
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="onPageChange"
        ></v-pagination>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import { handleAjaxError } from "@/utils/common";

export default {
  data() {
    return {
      searchMode: "card_id",
      card_id: "",
      name: "",
      surname: "",
      // department search
      listDepartment: [],
      listSubSubDepartment: [],
      treeFromDepartment: "",
      subSubDepartment: null,
      other: "",
      // location search
      listProvince: [],
      listAmphoe: [],
      listTambon: [],
      selectedProvince: null,
      selectedAmphoe: null,
      selectedTambon: null,
      // table sorting (server-side)
      tablePagination: {
        sortBy: "card_id",
        descending: false,
        page: 1,
        rowsPerPage: 10
      },
      // pending ids for async restore from query
      pendingProvinceId: null,
      pendingAmphoeId: null,
      pendingTambonId: null,
      pendingSubSubDepartmentId: null,
      pendingSubSubDepartmentParentId: null,
      menuProps: {
        closeOnClick: false,
        closeOnContentClick: true
      },
      // result + pagination
      items: [],
      totalCount: null,
      page: 1,
      pageSize: 10,
      loading: false,
      headers: [
        { text: "No.", value: "no", sortable: false },
        { text: "หมายเลขประจำตัวประชาชน", value: "card_id" },
        { text: "คำนำหน้าชื่อ", value: "title" },
        { text: "ชื่อ", value: "name" },
        { text: "นามสกุล", value: "surname" },
        { text: "หน่วยงาน", value: "companyname" },
        { text: "จำนวนต้นไม้ที่ปลูก", value: "total_plant_amount" },
        { text: "การกระทำ", value: "actions", sortable: false }
      ]
    };
  },
  computed: {
    pageCount() {
      if (!this.totalCount || !this.pageSize) return 0;
      return Math.ceil(this.totalCount / this.pageSize);
    }
  },
  created() {
    this.queryDepartment();
    this.querySubSubDepartment();
    this.queryProvince();
    this.syncFromRouteAndFetch();
  },
  watch: {
    "$route.query": {
      handler() {
        this.syncFromRouteAndFetch();
      }
    },
    selectedProvince(val) {
      this.selectedAmphoe = null;
      this.selectedTambon = null;
      if (val && val.province_id) {
        this.queryAmphoe();
      } else {
        this.listAmphoe = [];
        this.listTambon = [];
      }
    },
    selectedAmphoe(val) {
      this.selectedTambon = null;
      if (val && val.amphoe_id) {
        this.queryTambon();
      } else {
        this.listTambon = [];
      }
    }
  },
  methods: {
    onSearch() {
      const query = this.buildQueryFromUI();
      if (!query) return;
      // reset page when new search
      query.page = "1";
      query.page_size = String(this.pageSize);
      // keep or initialize sort
      if (!query.sort_field) {
        query.sort_field = this.tablePagination.sortBy || "card_id";
        query.sort_direction = this.tablePagination.descending ? "DESC" : "ASC";
      }
      this.$router.push({ path: "/admin/editplant", query });
    },
    onPageChange(newPage) {
      const query = Object.assign({}, this.$route.query || {});
      query.page = String(newPage);
      query.page_size = String(this.pageSize);
      this.$router.push({ path: "/admin/editplant", query });
    },
    buildQueryFromUI() {
      const trim = v => (v || "").toString().trim();
      const mode = this.searchMode;

      if (!mode) {
        this.$swal("กรุณาเลือกเกณฑ์การค้นหา", "", "error");
        return null;
      }

      const query = { mode };

      if (mode === "card_id") {
        const cardId = trim(this.card_id);
        if (!cardId) {
          this.$swal("กรุณากรอกเลขประจำตัวประชาชน", "", "error");
          return null;
        }
        query.card_id = cardId;
      } else if (mode === "name") {
        const name = trim(this.name);
        const surname = trim(this.surname);
        if (!name && !surname) {
          this.$swal("กรุณากรอกชื่อหรือนามสกุล", "", "error");
          return null;
        }
        if (name) query.name = name;
        if (surname) query.surname = surname;
      } else if (mode === "department") {
        if (!this.treeFromDepartment) {
          this.$swal("กรุณาเลือกหน่วยงาน", "", "error");
          return null;
        }
        query.department_id = String(this.treeFromDepartment);
        if (this.treeFromDepartment === 1 && this.subSubDepartment) {
          query.sub_department_id_level1 = String(
            this.subSubDepartment.parent_department_id
          );
          query.sub_department_id_level2 = String(
            this.subSubDepartment.department_id
          );
        }
        if (this.treeFromDepartment === 4 && this.other) {
          query.other = this.other;
        }
      } else if (mode === "location") {
        const provinceObj = this.selectedProvince;
        const amphoeObj = this.selectedAmphoe;
        const tambonObj = this.selectedTambon;

        if (!provinceObj && !amphoeObj && !tambonObj) {
          this.$swal(
            "กรุณาเลือกจังหวัด อำเภอ หรือ ตำบลอย่างน้อย 1 รายการ",
            "",
            "error"
          );
          return null;
        }

        if (provinceObj && provinceObj.province_id) {
          query.province_id = String(provinceObj.province_id);
        }
        if (amphoeObj && amphoeObj.amphoe_id) {
          query.amphoe_id = String(amphoeObj.amphoe_id);
        }
        if (tambonObj && tambonObj.tambon_id) {
          query.tambon_id = String(tambonObj.tambon_id);
        }
      } else {
        this.$swal("เกณฑ์การค้นหาไม่ถูกต้อง", "", "error");
        return null;
      }

      return query;
    },
    buildPayloadFromQuery(q) {
      const payload = {
        page: q.page ? parseInt(q.page, 10) || 1 : 1,
        page_size: q.page_size ? parseInt(q.page_size, 10) || 10 : 10
      };

      const mode = q.mode || "card_id";
      if (mode === "card_id" && q.card_id) {
        payload.card_id = q.card_id;
      } else if (mode === "name") {
        if (q.name) payload.name = q.name;
        if (q.surname) payload.surname = q.surname;
      } else if (mode === "department") {
        if (q.department_id) {
          payload.department_id = parseInt(q.department_id, 10);
        }
        if (q.sub_department_id_level1) {
          payload.sub_department_id_level1 = parseInt(
            q.sub_department_id_level1,
            10
          );
        }
        if (q.sub_department_id_level2) {
          payload.sub_department_id_level2 = parseInt(
            q.sub_department_id_level2,
            10
          );
        }
        if (q.other) {
          payload.other = q.other;
        }
      } else if (mode === "location") {
        if (q.province_id) {
          payload.province_id = parseInt(q.province_id, 10);
        }
        if (q.amphoe_id) {
          payload.amphoe_id = parseInt(q.amphoe_id, 10);
        }
        if (q.tambon_id) {
          payload.tambon_id = parseInt(q.tambon_id, 10);
        }
      }

      // sorting
      const sortField = q.sort_field || "card_id";
      const sortDirection = (q.sort_direction || "ASC").toUpperCase();
      payload.sort_field = sortField;
      payload.sort_direction = sortDirection;

      return payload;
    },
    syncFromRouteAndFetch() {
      const q = this.$route.query || {};

      // sync form
      this.searchMode = q.mode || "card_id";
      this.card_id = q.card_id || "";
      this.name = q.name || "";
      this.surname = q.surname || "";

      this.treeFromDepartment = q.department_id
        ? parseInt(q.department_id, 10)
        : "";
      if (this.searchMode === "department") {
        this.pendingSubSubDepartmentId = q.sub_department_id_level2
          ? parseInt(q.sub_department_id_level2, 10)
          : null;
        this.pendingSubSubDepartmentParentId = q.sub_department_id_level1
          ? parseInt(q.sub_department_id_level1, 10)
          : null;
      } else {
        this.subSubDepartment = null;
        this.pendingSubSubDepartmentId = null;
        this.pendingSubSubDepartmentParentId = null;
      }
      this.other = q.other || "";

      // location UI state
      if (this.searchMode === "location") {
        this.pendingProvinceId = q.province_id
          ? parseInt(q.province_id, 10)
          : null;
        this.pendingAmphoeId = q.amphoe_id
          ? parseInt(q.amphoe_id, 10)
          : null;
        this.pendingTambonId = q.tambon_id
          ? parseInt(q.tambon_id, 10)
          : null;
      } else {
        this.selectedProvince = null;
        this.selectedAmphoe = null;
        this.selectedTambon = null;
        this.pendingProvinceId = null;
        this.pendingAmphoeId = null;
        this.pendingTambonId = null;
      }

      this.page = q.page ? parseInt(q.page, 10) || 1 : 1;
      this.pageSize = q.page_size
        ? parseInt(q.page_size, 10) || 10
        : this.pageSize;

      // sync v-data-table internal pagination with pageSize
      this.tablePagination.page = this.page;
      this.tablePagination.rowsPerPage = this.pageSize;

      // sync sorting state
      const sortField = q.sort_field || "card_id";
      const sortDirection = (q.sort_direction || "ASC").toUpperCase();
      this.tablePagination.sortBy = sortField;
      this.tablePagination.descending = sortDirection === "DESC";

      if (Object.keys(q).length === 0) {
        this.items = [];
        this.totalCount = null;
        return;
      }

      const payload = this.buildPayloadFromQuery(q);
      this.fetchUsers(payload);
    },
    fetchUsers(payload) {
      this.loading = true;
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + "/queryUser",
          payload,
          { withCredentials: true }
        )
        .then(response => {
          const data = response.data || {};
          this.items = data.items || [];
          this.totalCount =
            typeof data.total_count === "number"
              ? data.total_count
              : (data.items || []).length;
          this.page = data.page || payload.page || 1;
          this.pageSize = data.page_size || payload.page_size || this.pageSize;

          // ensure v-data-table shows the same number of rows as pageSize
          this.tablePagination.page = this.page;
          this.tablePagination.rowsPerPage = this.pageSize;
        })
        .catch(error => {
          handleAjaxError(error, this);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onTablePagination(pagination) {
      const sortBy = pagination.sortBy || "card_id";
      const descending = !!pagination.descending;
      const sortField = sortBy;
      const sortDirection = descending ? "DESC" : "ASC";

      const current = this.$route.query || {};
      const currentField = current.sort_field || "card_id";
      const currentDirection = (current.sort_direction || "ASC").toUpperCase();

      if (currentField === sortField && currentDirection === sortDirection) {
        return;
      }

      const query = Object.assign({}, current);
      query.sort_field = sortField;
      query.sort_direction = sortDirection;
      query.page = "1";
      query.page_size = String(this.pageSize);

      this.$router.push({ path: "/admin/editplant", query });
    },
    queryDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryDepartment")
        .then(response => {
          this.listDepartment = response.data || [];
        });
    },
    queryProvince() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryProvince")
        .then(response => {
          this.listProvince = response.data || [];
          this.restoreLocationFromPending();
        });
    },
    queryAmphoe() {
      if (!this.selectedProvince || !this.selectedProvince.province_id) {
        this.listAmphoe = [];
        this.listTambon = [];
        return;
      }
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryAmphoe", {
          province_id: this.selectedProvince.province_id
        })
        .then(response => {
          this.listAmphoe = response.data || [];
          this.restoreLocationFromPending();
        });
    },
    queryTambon() {
      if (!this.selectedAmphoe || !this.selectedAmphoe.amphoe_id) {
        this.listTambon = [];
        return;
      }
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryTambon", {
          amphoe_id: this.selectedAmphoe.amphoe_id
        })
        .then(response => {
          this.listTambon = response.data || [];
          this.restoreLocationFromPending();
        });
    },
    querySubSubDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/querySubSubDepartment")
        .then(response => {
          this.listSubSubDepartment = response.data || [];
          this.restoreDepartmentFromPending();
        });
    },
    restoreLocationFromPending() {
      if (this.searchMode !== "location") return;

      // province จาก pending
      if (this.pendingProvinceId && this.listProvince && this.listProvince.length) {
        const pId = this.pendingProvinceId;
        const province = this.listProvince.find(
          x => parseInt(x.province_id, 10) === pId
        );
        if (province) {
          this.selectedProvince = province;
        }
        this.pendingProvinceId = null;
      }

      // amphoe จาก pending
      if (
        this.pendingAmphoeId &&
        this.listAmphoe &&
        this.listAmphoe.length &&
        this.selectedProvince &&
        this.selectedProvince.province_id
      ) {
        const aId = this.pendingAmphoeId;
        const amphoe = this.listAmphoe.find(
          x => parseInt(x.amphoe_id, 10) === aId
        );
        if (amphoe) {
          this.selectedAmphoe = amphoe;
        }
        this.pendingAmphoeId = null;
      }

      // tambon จาก pending
      if (
        this.pendingTambonId &&
        this.listTambon &&
        this.listTambon.length &&
        this.selectedAmphoe &&
        this.selectedAmphoe.amphoe_id
      ) {
        const tId = this.pendingTambonId;
        const tambon = this.listTambon.find(
          x => parseInt(x.tambon_id, 10) === tId
        );
        if (tambon) {
          this.selectedTambon = tambon;
        }
        this.pendingTambonId = null;
      }
    },
    restoreDepartmentFromPending() {
      if (this.searchMode !== "department") return;
      if (
        !this.pendingSubSubDepartmentId ||
        !this.listSubSubDepartment ||
        !this.listSubSubDepartment.length
      ) {
        return;
      }
      const did = this.pendingSubSubDepartmentId;
      const pid = this.pendingSubSubDepartmentParentId;

      const found = this.listSubSubDepartment.find(item => {
        if (pid !== null && pid !== undefined && item.parent_department_id !== undefined) {
          return (
            parseInt(item.department_id, 10) === did &&
            parseInt(item.parent_department_id, 10) === pid
          );
        }
        return parseInt(item.department_id, 10) === did;
      });

      if (found) {
        this.subSubDepartment = found;
      }

      this.pendingSubSubDepartmentId = null;
      this.pendingSubSubDepartmentParentId = null;
    },
    goToUserDetail(item) {
      const cardId = item.card_id;
      if (!cardId) return;
      this.$router.push({
        path: `/admin/users/${cardId}`
      });
    }
  },
  filters: {
    comma(val) {
      if (val === null || val === undefined) return "";
      return Number(val).toLocaleString();
    }
  }
};
</script>

<style scoped>
.box-card {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
}

.for-rfd {
  display: flex !important;
  flex-flow: column !important;
}

.for-other {
  display: flex !important;
}
</style>
